import type { ThemeVariantMap } from "@/theme/types";

import { apolloFoodTruckLightTheme } from "./apolloFoodTruck.light";

export const apolloFoodTruckTheme: ThemeVariantMap = {
  LIGHT: apolloFoodTruckLightTheme,
} as const;
